import { createSlice } from '@reduxjs/toolkit';

const competitionDetail = createSlice({
  name: 'competitionDetail',
  initialState: {},
  reducers: {
    setCompetitionDetail(state, action) {
      
      return action.payload;
    }
  }
});

export const { setCompetitionDetail } = competitionDetail.actions;
export default competitionDetail.reducer;